import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  shouldRefresh: false,
  removeCardVerification: {
    cardId: null,
    toBeRemoved: false
  },
  editCardId: null,
  cards: []
}

const cardsSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    removeCardVerification(state, action) {
      state.removeCardVerification = action.payload;
    },
    setCards(state, action) {
      state.cards = action.payload;
    },
    setEditCardId(state, action) {
      state.editCardId = action.payload;
    },
  },
})

export const {
  removeCardVerification,
  setCards,
  setEditCardId,
} = cardsSlice.actions

export default cardsSlice.reducer